<template>
  <div id="electronicInvoice">
    <div class="invoiceContainer">
      <div class="electronic">
        <div v-for="(item, index) in detailInfo" :key="index">
          <div class="invoiceImg">
            <img class="img" :src="`${uploadUrl}${item.invoiceImgId}`" alt="" />
          </div>
          <div class="invoiceContent">{{ item.description }}</div>
        </div>
      </div>

      <div class="consult">
        <div>
          如仍有疑问，仍无法解决，点击咨询
          <span @click="service" style="color: #2485e6">人工客服</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "electronicInvoice",
  data() {
    return {
      detailInfo: [],
      uploadUrl: ""
    };
  },
  created() {
    if (JSON.parse(sessionStorage.getItem('invoiceInfo'))) {
      this.detailInfo=JSON.parse(sessionStorage.getItem('invoiceInfo')).invoicesDescriptionList
    }
  },
  mounted() {
    this.uploadUrl = apis.uploadUrl;
  },
  methods: {
    // 人工客服
    service() {
      // window.open("https://work.weixin.qq.com/kfid/kfc8970885ac4a02586");
      window.open("https://work.weixin.qq.com/kfid/kfcfce44ed386dd434f");
      
    }
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #electronicInvoice {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #electronicInvoice {
    width: 276px * $zoom;
  }
}
#electronicInvoice {
  font-size: 16px * $zoom;
  

  .invoiceContainer {
    display: flex;
    flex-direction: column;
    height: 100vh;
    
    .electronic {
      padding: 0 30px;
      flex: 1;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .invoiceImg {
        // width: 608px;
        height: 385px;
        margin-bottom: 22px;
        margin-top: 30px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .invoiceContent {
        font-size: 27px;
        text-indent: 2em;
      }
    }
    .consult {
      height: 60px;
      line-height: 60px;
      font-size: 22px;
      color: #848485;
      div {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
